<template>
  <div class="box flap-long-word">
    <article class="level is-mobile is-marginless">
      <div class="level-left"></div>
      <div class="level-right">
        <div class="level-item">
          <button type="button" v-on:click="order_Open_Edit">
            <b-icon icon="edit"></b-icon>
          </button>
          <div class="level-item">
            <button type="button" v-on:click="order_Open_Delete">
              <b-icon icon="trash" type="is-danger"></b-icon>
            </button>
          </div>
        </div>
      </div>
    </article>
    <article class="columns is-mobile">
      <div class="column full-width">{{name}}</div>
    </article>
    <article class="columns is-mobile">
      <section class="column">
        <div class="columns is-mobile">
          <section class="column is-one-third is-rightpadding-less">
            <p>価格:</p>
          </section>
          <div class="column is-leftpadding-less">
            <section class="level is-mobile">
              <div class="level-item is-marginless">
                <b-icon pack="fas" icon="yen-sign"></b-icon>
              </div>
              <div class="level-item">
                <p>{{price}}</p>
              </div>
            </section>
          </div>
        </div>
      </section>
      <section class="column">
        <div class="columns is-mobile">
          <section class="column">
            <button
              class="button is-danger"
              type="button"
              v-on:click="remove_Number"
              v-bind:disabled="number == 0"
            >
              <b-icon icon="minus-square"></b-icon>
            </button>
          </section>
          <section class="column">
            <p>{{ number }}</p>
          </section>
          <section class="column">
            <button class="button is-success" type="button" v-on:click="add_Number">
              <b-icon icon="plus-square"></b-icon>
            </button>
          </section>
        </div>
      </section>
    </article>
  </div>
</template>

<script>
export default {
  name: "product",
  props: {
    product: Object
  },
  data: function() {
    return {
      number: 0,
      name: this.product.data().name,
      price: this.product.data().price
    };
  },
  methods: {
    // 親に対して編集画面を開くように命令
    order_Open_Edit: function() {
      this.$store.dispatch("product/display_Edit", this.product);
      this.$emit("order_Open_Edit");
    },
    // 親に対して削除画面を開くように命令
    order_Open_Delete: function() {
      this.$store.dispatch("product/display_Delete", this.product);
      this.$emit("order_Open_Delete");
    },
    add_Number: function() {
      this.$store.dispatch("product/display_Total_Price", {
        pay_price: this.price,
        detail: this.product
      });

      this.number = this.number + 1;
    },
    remove_Number: function() {
      this.$store.dispatch("product/display_Total_Price", {
        pay_price: -this.price,
        detail: this.product
      });

      this.number = this.number - 1;
    }
  }
};
</script>

<style>
.is-rightpadding-less {
  padding-right: 0;
}

.is-leftpadding-less {
  padding-left: 0;
}
</style>
